import { createFileRoute, redirect } from '@tanstack/react-router';
import { SignUpPage } from '@/features/auth/pages/sign-up-page';
import { meQueryOptions } from '@/lib/me';

/**
 * Self-serve signup for a new shop owner. Already signed in -> straight on to opening a shop.
 * `industry` and `plan` come from the sales page (www.coreup.pro) and pre-select the business type and the package to
 * try free on the next step.
 */
export const Route = createFileRoute('/_auth/sign-up')({
  validateSearch: (s: Record<string, unknown>): { industry?: string; plan?: string; ref?: string } => ({
    industry: typeof s.industry === 'string' && s.industry ? s.industry : undefined,
    plan: typeof s.plan === 'string' && s.plan ? s.plan : undefined,
    ref: typeof s.ref === 'string' && s.ref ? s.ref : undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient
      .ensureQueryData({ ...meQueryOptions, retry: false })
      .catch(() => null);
    if (me)
      throw search.industry || search.plan || search.ref
        ? redirect({ to: '/onboarding', search })
        : redirect({ to: '/' });
  },
  component: SignUpPage,
});
